import { Col, Container, Row } from 'react-bootstrap'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../../common/integrations'
import { useCallback, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import { MappingType } from '../../../../../../../models/Account'
import { useGetIntegrationAdminSettings, useSyncAdditionalObjects } from '../../../hooks'
import { SelectSessionTypeSection } from './SelectSessionTypeSection'
import { PredefinedSessionAdminSettings } from './PredefinedSessionAdminSettings'
import { CustomSessionAdminSettings } from './CustomSessionAdminSettings'
import { MeetingSummaryMappingTester } from '../../../../TesterTool/MeetingSummary/MeetingSummaryMappingTester'
import { IntegrationMappingTesterAccordion } from '../../../../TesterTool/TesterAccordion'

export interface SessionAdminSettingsProps {
  serviceId: IntegrationServiceId
  disabled?: boolean
}

export const SessionAdminSettings: React.FC<SessionAdminSettingsProps> = ({ serviceId, disabled }) => {
  const [formKey, setFormKey] = useState<number>(0)
  const { watch, getValues, setValue } = useFormContext<IntegrationSettings>()
  const currentMappingType = watch('mappings.session.mappingType')
  const syncAdditionalObjects = useSyncAdditionalObjects(getValues, setValue)
  const isCustom = useMemo(() => currentMappingType === MappingType.CUSTOM, [currentMappingType])

  const refreshForm = useCallback(() => {
    setFormKey((prevKey) => prevKey + 1)
    syncAdditionalObjects()
  }, [syncAdditionalObjects])

  const { isAccountFetching } = useGetIntegrationAdminSettings(serviceId)

  if (isAccountFetching) {
    return (
      <Container>
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
      </Container>
    )
  }

  return (
    <Container className='py-3'>
      <Row className='mb-3'>
        <Col>
          <h3 className='mb-2'>Meeting summary</h3>
          <div className='zocks-text-gray-600'>Configure where Zocks saves ‘Meeting Summary’ in {getIntegrationDisplayName(serviceId)}.</div>
        </Col>
      </Row>
      <Row>
        <SelectSessionTypeSection onChange={refreshForm} serviceId={serviceId} disabled={disabled} />
      </Row>
      {isCustom ? (
        <>
          <Row>
            <CustomSessionAdminSettings serviceId={serviceId} formKey={formKey} onChange={syncAdditionalObjects} />
          </Row>
          <Row className='mt-5'>
            <IntegrationMappingTesterAccordion serviceId={serviceId} testerComponents={[MeetingSummaryMappingTester]} title='Test Meeting Export' />
          </Row>
        </>
      ) : (
        <Row>
          <PredefinedSessionAdminSettings serviceId={serviceId} key={formKey} disabled={disabled} />
        </Row>
      )}
    </Container>
  )
}
